function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\xE5\x85\xB3\xE9\x97\xAD\xE6\x8C\x89\xE9\x92\xAE\xE5\xA4\x87\xE4\xBB\xBD"
}, /*#__PURE__*/React.createElement("rect", {
  id: "\xE7\x9F\xA9\xE5\xBD\xA2",
  opacity: 0.01,
  width: 26,
  height: 26,
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  id: "\xE8\xB7\xAF\xE5\xBE\x84",
  d: "M14.3154 13L20.9805 5.05527C21.0922 4.92324 20.9983 4.72266 20.8256 4.72266H18.7994C18.6801 4.72266 18.5658 4.77598 18.4871 4.86738L12.99 11.4207L7.49298 4.86738C7.41681 4.77598 7.30255 4.72266 7.18067 4.72266H5.1545C4.98184 4.72266 4.8879 4.92324 4.99962 5.05527L11.6647 13L4.99962 20.9447C4.8879 21.0768 4.98184 21.2773 5.1545 21.2773H7.18067C7.30001 21.2773 7.41427 21.224 7.49298 21.1326L12.99 14.5793L18.4871 21.1326C18.5633 21.224 18.6775 21.2773 18.7994 21.2773H20.8256C20.9983 21.2773 21.0922 21.0768 20.9805 20.9447L14.3154 13Z",
  fill: "white"
}));

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.5f7e253a.svg";
export { ForwardRef as ReactComponent };